import {
  GetYearOverYearRevenueReportQuery,
  useGetYearOverYearRevenueReportQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

const useGetYearOverYearRevenueReport = () => {
  const {
    data: graphqlData,
    error,
    loading,
  } = useGetYearOverYearRevenueReportQuery({
    fetchPolicy: "network-only",
  });

  const getData = useCallback(({ data }: { data?: GetYearOverYearRevenueReportQuery }) => {
    return data?.getYearOverYearRevenueReport?.data || [];
  }, []);

  const data = useMemo(() => getData({ data: graphqlData }), [getData, graphqlData]);

  return {
    loading,
    data,
    error,
    getData,
  } as const;
};

export default useGetYearOverYearRevenueReport;
